import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-318159dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-full flex flex-col justify-between overflow-y-auto o-scrollbar pr-20 relative"
}
const _hoisted_2 = { class: "-mt-20" }
const _hoisted_3 = { class: "pt-30 pb-50" }
const _hoisted_4 = { class: "text-16 flex justify-between" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "text-16 c-magic-line"
}
const _hoisted_8 = {
  key: 1,
  class: "text-16 c-magic-line"
}
const _hoisted_9 = {
  key: 1,
  class: "flex gap-x4"
}
const _hoisted_10 = { key: 1 }

import { computed } from 'vue';
import navigationStore from '@/shared/navigation/navigation.store';
import siteContextStore from '@/shared/content/site-context.store';
import { NavigationItemModel } from '@/types/B2CcontentServerContract';
import ToggleNetPrice from '@/b2b/shared/auth/ui/ToggleNetPrice.vue';
import NavigationRenderer from '@/shared/navigation/site-navigation/NavigationRenderer.vue';
import useProfile from '@/shared/navigation/site-navigation/useProfile';
import pageStore from '@/shared/content/page.store';
import SearchArea from '@/shared/search/ui/SearchArea.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainNavigationMobile',
  setup(__props) {

const { shouldShowToggleNetPrice, shouldShowCountrySelection } = useProfile();

const languages = computed(() => siteContextStore.getLanguages());
const country = computed(() => siteContextStore.getCountry());
const localizedCountry = computed(() => siteContextStore.getLocalizedCountry());
const items = computed<NavigationItemModel[]>(() => {
    const myBoliaNavigation = navigationStore.myBoliaNavigation[0]?.items ?? [];
    const sortedTopLevelNavigationItems = [...navigationStore.mainLeftNavigation, ...navigationStore.mainRightNavigation, ...myBoliaNavigation];
    return sortedTopLevelNavigationItems;
});

return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (!_unref(navigationStore).hasActiveSearch)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
          _createVNode(NavigationRenderer, { items: _unref(items) }, null, 8, ["items"])
        ]),
        _createElementVNode("footer", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_unref(shouldShowCountrySelection))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("a", {
                    href: _unref(pageStore).changeCountryUrl,
                    class: "flex items-center"
                  }, [
                    _createVNode(_component_c_icon, {
                      name: "icon-map",
                      class: "language-icon w-13 h-18 mr-x2"
                    }),
                    (_unref(localizedCountry) || _unref(country).name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(localizedCountry) || _unref(country).name), 1))
                      : (_unref(country).code === 'en')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$dictionary.get('global/generic/international')), 1))
                        : _createCommentVNode("", true)
                  ], 8, _hoisted_6)
                ]))
              : _createCommentVNode("", true),
            (_unref(languages).length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (language) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(language.current ? 'span' : 'a'), {
                      key: language.languageCode,
                      href: language.current ? undefined : '/' + language.languageCode,
                      title: language.name,
                      class: _normalizeClass([{ 'c-magic-line c-magic-line--underline-static': language.current }, "text-14 uppercase"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(language.twoLetterISOLanguageName), 1)
                      ]),
                      _: 2
                    }, 1032, ["href", "title", "class"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (_unref(shouldShowToggleNetPrice))
              ? (_openBlock(), _createBlock(ToggleNetPrice, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("section", _hoisted_10, [
        _createVNode(SearchArea)
      ]))
}
}

})